import { render } from "./DsoRiderStepTwo.vue?vue&type=template&id=92893390&scoped=true"
import script from "./DsoRiderStepTwo.vue?vue&type=script&lang=js"
export * from "./DsoRiderStepTwo.vue?vue&type=script&lang=js"

import "./DsoRiderStepTwo.vue?vue&type=style&index=0&id=92893390&scoped=true&lang=css"

import exportComponent from "/opt/render/project/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-92893390"]])

export default __exports__